import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { periverseTheme } from '@peritasai/ui-shared';
import { useAuthContext } from '../features/auth';
import type { RouterContext } from '../app/providers/router-provider';

export const Route = createRootRouteWithContext<RouterContext>()({
  // 2. We no longer define the context here.
  // The type and value are handled by RouterProviderWrapper.
  component: RootLayout,
  notFoundComponent: NotFound,
});

function RootLayout() {
  const { isLoading, isInitialized } = useAuthContext();

  // Show loading state while checking authentication
  if (isLoading || !isInitialized) {
    return (
      <div 
        className="min-h-screen flex items-center justify-center"
        style={{ backgroundColor: periverseTheme.palette.background.default }}
      >
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div 
      className="min-h-screen"
      style={{ backgroundColor: periverseTheme.palette.background.default }}
    >
      <Outlet />
    </div>
  );
}

function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white text-center">
      <div className="text-[120px] leading-none font-bold text-gray-800">
        404
      </div>
      <div className="mt-4 text-sm text-gray-500 tracking-wide">
        We are sorry, but the page you requested was not found.
      </div>
    </div>
  );
}
